export class password_hash_request {
    public api_key: string;
  }
  